import { render, staticRenderFns } from "./Comparator.vue?vue&type=template&id=0eee8b06&scoped=true&"
import script from "./Comparator.vue?vue&type=script&lang=js&"
export * from "./Comparator.vue?vue&type=script&lang=js&"
import style0 from "./Comparator.vue?vue&type=style&index=0&id=0eee8b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee8b06",
  null
  
)

export default component.exports